import { AcademictimetableActions } from "./action";

const initialState = {
  AcademictimetableData: {
    academic_timetable: []
  },
};

export const AcademictimetableReducer = (state = initialState, action) => {
  switch (action.type) {
    case AcademictimetableActions.SET_ACADEMIC_TIMETABLE:
      return {
        ...state,
        AcademictimetableData: {
          academic_timetable: Array.isArray(action.payload?.academic_timetable) 
            ? action.payload.academic_timetable 
            : action.payload?.academic_timetable 
              ? [action.payload.academic_timetable]
              : []
        },
      };

    default:
      return state;
  }
};